import styled from 'styled-components';

export const UploadContainer = styled.div`
  border: 2px dashed ${props => props.theme.colors.gray200};
  border-radius: ${props => props.theme.borderRadius.md};
  padding: ${props => props.theme.spacing.xl};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.gray100};
  cursor: pointer;
  transition: all 0.2s;
  min-height: 200px;
  
  &:hover {
    border-color: ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.primary}05;
  }
`;

export const UploadIconWrapper = styled.div`
  color: ${props => props.theme.colors.gray400};
  margin-bottom: ${props => props.theme.spacing.md};
`;

export const UploadTitle = styled.h4`
  color: ${props => props.theme.colors.textPrimary};
  font-weight: 500;
  margin-bottom: ${props => props.theme.spacing.xs};
`;

export const UploadSubtitle = styled.p`
  color: ${props => props.theme.colors.textSecondary};
  font-size: 0.875rem;
`;
